/* eslint-disable no-console */
import React, { ReactNode, useContext, useEffect } from 'react';
import cookie from 'react-cookies';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, useHistory } from 'react-router-dom';

import RootState from '@src/interfaces/RootState';
import { REFRESH_TOKEN } from '@src/redux/auth/actions';
import { useTranslation } from 'react-i18next';
import { AuthContext } from './authContext';

interface PrivateRouteProps {
    children: ReactNode;
    exact?: boolean;
    props?: any;
    path?: string;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const PrivateRoute: React.FC<PrivateRouteProps> = ({ children, ...rest }) => {
    /* STATES */

    /* VARIABLES */
    const { t } = useTranslation('common');
    const dispatchStore = useDispatch();
    const {
        authState: { isAuthenticated },
    } = React.useContext<any>(AuthContext);
    const { authDispatch } = useContext<any>(AuthContext);
    const history = useHistory();

    /* FUNCTIONS */
    const logOut = () => {
        sessionStorage.removeItem('username');
        sessionStorage.removeItem('token');
        authDispatch({ type: 'SIGNED_OUT' });
        history.replace('/');
    };

    const refreshToken = () => {
        dispatchStore({ type: REFRESH_TOKEN });
    };

    const handleLogout = () => {
        if (isAuthenticated) {
            logOut();
        }
    };

    const handleOnIdle = () => {
        if (isAuthenticated) {
            refreshToken();
            reset();
        }
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleOnActive = (event) => {};
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleOnAction = () => {};

    const { reset } = useIdleTimer({
        timeout: 1000 * 180 * 1,
        onIdle: handleOnIdle,
        onActive: handleOnActive,
        onAction: handleOnAction,
        debounce: 500,
    });

    const { getRemainingTime } = useIdleTimer({
        timeout: 1000 * 1800 * 1,
        onIdle: handleLogout,
        debounce: 500,
    });

    /* USEEFFECTS */
    useEffect(() => {
        if (!isAuthenticated) {
            console.log('Logged out');
            history.replace('/');
        }
    }, [isAuthenticated]);

    useEffect(() => {
        if (!sessionStorage.getItem('token')) {
            logOut();
            return;
        }
        if (isAuthenticated) {
            refreshToken();
        } else {
            logOut();
        }
    }, []);
    return (
        <Route
            {...rest}
            render={({ location }) =>
                isAuthenticated ? (
                    children
                ) : (
                    <Redirect
                        to={{
                            pathname: '/',
                            state: { from: location },
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateRoute;
